import { useParams } from "react-router-dom";
import DataFetcherTemplate from "../../hooks/fetchTemplate";
import BannerGeneral from "../../components/BannerGeneral";
import BlockBackgroundImage from "../../components/BlockBackgroundImage";
import BlockImageCabecera from "../../components/BlockImageCabecera";
import PosgradoPagos from "../../components/PosgradoPagos";
import Notification from "../../components/Notification";
import Breadcumbs from "../../components/Breadcumbs";
import { NavLink } from "react-router-dom";
import ConectUs from "../../components/ConectUs";
import { PosgradosHome } from "../../components/Pasos";
import OfferPosgrados from "../../components/view/OfferPosgrados";

function Posgrados() {
  const { facultad } = useParams();

  const facultadMap = {
    empresas: "Ciencias Económicas y Empresariales",
    salud: "Ciencias de la Salud",
    ingenieria: "Ingenierías y Arquitectura",
    sociales: "Ciencias Sociales, Educación y Humanidades",
  };

  const facultadReal = facultadMap[facultad];

  const DataDisplay = ({ data }) => {
    let filteredData = data;

    if (facultadReal) {
      filteredData = data.filter((item) => item.facultad === facultadReal);
    }

    return (
      <>
        <div>
          {filteredData.map((item, index) => (
            <div key={index}>
              <BlockImageCabecera
                src={item.field_portada}
                title={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_texto_portada,
                    }}
                  />
                }
              />

              <div className="relative">
                <Notification
                  content={
                    <>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque1,
                        }}
                      />
                      <PosgradosHome />
                    </>
                  }
                />
              </div>

              <Breadcumbs
                content={
                  <>
                    <NavLink to="/posgrados">Posgrados</NavLink>
                    {facultad && <> / {facultad}</>}
                  </>
                }
              />

              <div
                className="layout8"
                dangerouslySetInnerHTML={{
                  __html: item.field_bloque2,
                }}
              />

              <div>
                <OfferPosgrados facultad={facultadReal} />
              </div>

            {/*   <div className="padding2">
                <PosgradoPagos />
              </div> */}

              <div className="margin">
                <BlockBackgroundImage
                  src={item.field_imagen4}
                  content={
                    <div
                      className="layout8"
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque4,
                      }}
                    />
                  }
                />
              </div>
            </div>
          ))}
        </div>
      </>
    );
  };

  return (
    <>
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/oferta/servicio-posgrados-new.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>

      <div className="padding2">
        <ConectUs
          lema="Descubre contenido exclusivo, mantente al tanto de las últimas novedades y únete a nuestra comunidad de estudiantes de posgrado."
          instagram="https://www.instagram.com/utplposgrados/"
          facebook="https://www.facebook.com/utplposgrados"
        ></ConectUs>
      </div>

      <BannerGeneral />
    </>
  );
}

export default Posgrados;
